// Outils du mode développeur (?dev dans l'adresse), pour tester sans attendre.
import { round2 } from '../engine/finance';
import type { GameState } from '../engine/state';
import { DAYS_PER_YEAR } from '../engine/time';
import { payFromCash } from './actions';
import { eligibleEvents, startEvent } from './events';
import { startFirstJob } from './progress';
import { advanceDays } from './sim';
import { energyMax } from './work';

export const DEV_SPEEDS = [1, 16, 60, 600];

export function setDevSpeed(state: GameState, speed: number): void {
  state.speed.dev = speed;
}

export function devAddMoney(state: GameState): void {
  state.cash = round2(state.cash + 1000);
}

/** Un vrai paiement de 500 € : le découvert, ses frais et ses agios s'appliquent comme en jeu. */
export function devSpend(state: GameState): void {
  payFromCash(state, 500);
}

export function devFillEnergy(state: GameState): void {
  if (state.energyUnlocked) state.energy = energyMax(state);
}

export function devTriggerEvent(state: GameState): void {
  if (state.pendingEvent) return;
  const candidates = eligibleEvents(state);
  if (candidates.length > 0) startEvent(state, candidates[Math.floor(Math.random() * candidates.length)].id);
}

export function devFirstJob(state: GameState): void {
  if (state.stage === 'prologue' && state.prologueStep === 'years') startFirstJob(state);
}

export function devAdvanceYear(state: GameState): void {
  advanceDays(state, DAYS_PER_YEAR, true);
}

export function devAddReserve(state: GameState): void {
  state.reserveDays += DAYS_PER_YEAR;
}
